module.exports = __webpack_public_path__ + "assets/img/moondecor.bccc6ec1.svg";